import styled from 'styled-components';

export const StldRow = styled.div`

    ${(props) => (!!props.width ? "width: " + props.width : "width: 100%")};
    ${(props) => (!!props.height ? "height: " + props.height : "height: 100%")};
    ${(props) => (!!props.marginLeft ? "margin-left: " + props.marginLeft : "margin-left: 0")};

    &::after {
        content: "";
        clear: both;
        display: table;
    }
`;

//marginLeft={'.5rem'}